module.exports = __webpack_public_path__ + "static/media/Artboard – 7.8759fbfe.svg";